import Vue from 'vue';

export class ToastsService {
  public static success(message: string) {
    Vue.toasted.show((message),
      { className: 'success' },
    );
  }

  public static warning(message: string) {
    Vue.toasted.show((message),
      { className: 'warning' },
    );
  }

  public static error(message: string) {
    Vue.toasted.show((message),
      { className: 'error' },
    );
  }

  public static info(message: string) {
    Vue.toasted.show((message),
      { className: 'info' },
    );
  }
}
